import ConsentBanner from "@/components/consent-banner"
import ErrorBoundary from "@/components/error-boundary"
import Footer from "@/components/footer"
import { Navbar } from "@/components/navbar"
import { CartProvider } from "@/lib/context/cart"
import { ToastProvider } from "@/lib/context/toast-context"
import { Outlet } from "@tanstack/react-router"

const Layout = () => {
  return (
    <ToastProvider>
      <CartProvider>
        <div className="site-shell min-h-screen flex flex-col">
          <a
            href="#main-content"
            className="sr-only rounded-full bg-white px-4 py-2 font-semibold text-[#5F5156] shadow-lg outline-2 outline-offset-2 outline-[#F5928A] focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100]"
          >
            Skip to content
          </a>
          <Navbar />

          <main
            id="main-content"
            tabIndex={-1}
            className="site-main relative flex-1 focus:outline-none"
          >
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>

          <Footer />
        </div>

        <ConsentBanner />
      </CartProvider>
    </ToastProvider>
  )
}

export default Layout
